import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../../Features/couponsSlice';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import SearchIcon from '../../../../../Assets/OrderManagement/SearchIcon.svg';
import ChevronDown from '../../../../../Assets/ChevronDownLargeDarkMode.svg';
import { getCategoryCollections } from '../../../../../lib/utils/apiCalls';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { AddCouponFormContext } from '../../../../../Context/Coupons/AddCouponFormContext';
import { useNavigate } from 'react-router-dom';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { apiV1 } from '../../../../../Auth/Interceptor';

function SelectCategoryCollection() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        handleCloseButtonClick();
    });

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const { setSelectedCategory, setSelectedCollection, setSelectionType, selectedProducts, setSelectedProducts, selectedCustomCollection, setSelectedCustomCollection } = useContext(AddCouponFormContext);

    const [categories, setCategories] = useState([]);
    const [collections, setCollections] = useState([]);

    const [selectedLocalCategory, setSelectedLocalCategory] = useState({});

    const [categorySearchList, setCategorySearchList] = useState([]);
    const [collectionSearchList, setCollectionSearchList] = useState([]);

    const [categorySearchText, setCategorySearchText] = useState('');
    const [collectionSearchText, setCollectionSearchText] = useState('');

    const [selectedCollectionId, setSelectedCollectionId] = useState('');

    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleCategoryClick = (category) => {
        setSelectedLocalCategory(category);
    }

    const handleCollectionClick = (e) => {
        setSelectedCollectionId(e.target.value);
    }

    const handleBack = () => {
        setSelectedLocalCategory({});
        setSelectedCollectionId('');
        setCollectionSearchText('');
    }

    const handleCategorySearch = (e) => {
        setCategorySearchText(e.target.value);
    }

    const handleCategorySearchKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(categorySearchText) {
                const filteredList = categories.filter(category => category.categoryName.toLowerCase().includes(categorySearchText.toLowerCase()));
                setCategorySearchList(filteredList);
            }
        }
    }

    const handleCollectionSearch = (e) => {
        setCollectionSearchText(e.target.value);
    }

    const handleCollectionSearchKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(collectionSearchText) {
                const filteredList = collections.filter(collection => collection.CollectionName.toLowerCase().includes(collectionSearchText.toLowerCase()));
                if(filteredList.some(collection => collection.id !== selectedCollectionId)) {
                    setSelectedCollectionId('');
                }
                setCollectionSearchList(filteredList);
            }
        }
    }

    const handleSetCollection = () => {
        if(buttonAvailable) {
            setSelectedCategory(selectedLocalCategory);
            const collection = collectionSearchList.find(item => item.id === selectedCollectionId);
            setSelectedCollection(collection);
            if(selectedProducts.length > 0) {
                setSelectedProducts([]);
            }
            if(Object.keys(selectedCustomCollection).length > 0) {
                setSelectedCustomCollection({});
            }
            setSelectionType('category-collection');
            dispatch(closeModal());
        }
        else {
            showToast('Please select a collection.', 'warning');
        }
    }

    const handleCreateCategory = () => {
        dispatch(closeModal());
        navigate('/collections/categories/add-category');
    }

    const handleCreateCollection = () => {
        dispatch(closeModal());
        navigate(`/collections/categories/${selectedLocalCategory.id}/collection/add-collection`);
    }

    useEffect(() => {
        if(selectedCollectionId) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedCollectionId]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await apiV1.get('category/getAll');
                if(response?.status === 200) {
                    setCategories(response.data.data.category);
                    setCategorySearchList(response.data.data.category);
                }
                else {
                    showToast('Error fetching categories.', 'error');
                }
            }
            catch(err) {
                showToast('Error fetching categories.', 'error');
            }
        }

        fetchCategories();
    }, []);

    useEffect(() => {
        const fetchCategoryCollections = async () => {
            try {
                const response = await getCategoryCollections(selectedLocalCategory.id);
                if(response?.status === 200) {
                    setCollections(response.data.data.collection);
                    setCollectionSearchList(response.data.data.collection);
                }
                else {
                    showToast('Error fetching collections.', 'error');
                }
            }
            catch(err) {
                showToast('Error fetching collections.', 'error');
            }
        }

        Object.keys(selectedLocalCategory).length > 0 && fetchCategoryCollections();
    }, [selectedLocalCategory]);

    useEffect(() => {
        if(!categorySearchText) {
            setCategorySearchList(categories);
        }
        // eslint-disable-next-line
    }, [categorySearchText]);

    useEffect(() => {
        if(!collectionSearchText) {
            setCollectionSearchList(collections);
        }
        // eslint-disable-next-line
    }, [collectionSearchText]);

    return (
        <div ref={wrapperRef} className='w-[28%] rounded-[20px] overflow-hidden bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D] relative'>
            <div className="flex items-center justify-between pt-[18px] pl-6 pr-2 w-full">
                <h1 className='font-semibold text-2xl text-[#121212]'>Set Category Collection</h1>

                <button className='size-11 flex items-center justify-center outline-none' onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            {
                Object.keys(selectedLocalCategory).length === 0 && 
                <>
                    <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-4 py-[10px] rounded-lg flex items-center gap-1 mx-6 mt-2">
                        <div className="size-5 flex items-center justify-center">
                            <img src={SearchIcon} alt="" />
                        </div>

                        <input 
                            className='w-[calc(100%-20px)] bg-transparent outline-none font-medium text-[14px] leading-[22px] text-[#121212] placeholder:text-[#666666]' 
                            type="text" 
                            placeholder='Search category' 
                            value={categorySearchText} 
                            onChange={handleCategorySearch} 
                            onKeyDown={handleCategorySearchKeyDown} 
                        />
                    </div>

                    <div className="mt-4 flex flex-col max-h-96 overflow-y-scroll no-scrollbar">
                        {
                            categories.length > 0 ?
                            <>
                                {categorySearchList?.map(category => {
                                    return (
                                        <button onClick={() => handleCategoryClick(category)} key={category.id} className="px-6 py-3 flex items-center gap-2 hover:bg-[#F5F5F5] outline-none cursor-pointer">
                                            <div className="size-[52px] flex items-center justify-center bg-[#D9D9D9] rounded-lg overflow-hidden">
                                                <img className='size-full object-cover' src={getCachedMediaUrl(category.categoryImgUrl[0])} alt={category.categoryName} />
                                            </div>

                                            <p className='font-medium text-[16px] leading-5 text-[#000000] w-[calc(100%-24px-52px)] whitespace-nowrap overflow-hidden text-ellipsis'>{category.categoryName}</p>

                                            <div className='-rotate-90 size-6 flex items-center justify-center'>
                                                <img src={ChevronDown} alt="" />
                                            </div>
                                        </button>
                                    )
                                })}
                            </> : 
                            <div className='px-6 pt-3 pb-4'>
                                <p className='italic text-[14px] leading-[26px] text-[#666666]'>Oops! Looks like you don't have any categories. <span onClick={handleCreateCategory} className='cursor-pointer text-[#4F46E5]'>Create one here</span>.</p>
                            </div>
                        }
                    </div>
                </>
            }

            {
                Object.keys(selectedLocalCategory).length > 0 && 
                <>
                    <div className="px-6 py-3 flex items-center gap-2 mt-2">
                        <button onClick={handleBack} className="size-6 flex items-center justify-center outline-none">
                            <img className='size-[14px] rotate-90' src={ChevronDown} alt="" />
                        </button>

                        <p className='w-[calc(100%-24px)] font-medium text-[16px] leading-5 text-[#000000] whitespace-nowrap overflow-hidden text-ellipsis'>{selectedLocalCategory.categoryName}</p>
                    </div>

                    <div className="border border-[#EAEAEA] bg-[#F5F5F5] px-4 py-[10px] rounded-lg flex items-center gap-1 mx-6 mt-2">
                        <div className="size-5 flex items-center justify-center">
                            <img src={SearchIcon} alt="" />
                        </div>

                        <input 
                            className='w-[calc(100%-20px)] bg-transparent outline-none font-medium text-[14px] leading-[22px] text-[#121212] placeholder:text-[#666666]' 
                            type="text" 
                            placeholder='Search collection' 
                            value={collectionSearchText} 
                            onChange={handleCollectionSearch} 
                            onKeyDown={handleCollectionSearchKeyDown} 
                        />
                    </div>

                    <div className="mt-4 flex flex-col mb-[84px] max-h-96 overflow-y-scroll no-scrollbar">
                        {
                            collections.length > 0 ? 
                            <>
                                {collectionSearchList?.map(collection => {
                                    return (
                                        <label htmlFor={`${collection.id}-radio`} key={collection.id} className="px-6 py-3 flex items-center gap-2 hover:bg-[#F5F5F5] cursor-pointer">
                                            <div className="cursor-pointer size-4 flex items-center justify-center">
                                                <div className={`size-full rounded-full border flex items-center justify-center ${selectedCollectionId === collection.id ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                                    {
                                                        selectedCollectionId === collection.id && 
                                                        <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                                                    }
                                                </div>
                                            </div>

                                            <div className='w-[calc(100%-16px-8px)] select-none flex items-center gap-2'>
                                                <input 
                                                    id={`${collection.id}-radio`} 
                                                    value={collection.id} 
                                                    type="radio" 
                                                    checked={selectedCollectionId === collection.id} 
                                                    onChange={handleCollectionClick} 
                                                    className='hidden' 
                                                />

                                                <div className="size-[52px] rounded-[7px] overflow-hidden flex items-center justify-center bg-[#D9D9D9]">
                                                    <img className='size-full object-cover' src={getCachedMediaUrl(collection?.CollectionImgUrl[0])} alt="" />
                                                </div>

                                                <p className='w-[calc(100%-52px-8px)] whitespace-nowrap overflow-hidden text-ellipsis font-medium text-[16px] leading-5 text-[#000000]'>{collection.CollectionName}</p>
                                            </div>
                                        </label>
                                    )
                                })}
                            </> : 
                            <div className='px-6 pt-3 pb-4'>
                                <p className='italic text-[14px] leading-[26px] text-[#666666]'>Oops! Looks like <span className='font-semibold'>{selectedLocalCategory.categoryName}</span> doesn't have any collections. <span onClick={handleCreateCollection} className='cursor-pointer text-[#4F46E5]'>Create one here</span>.</p>
                            </div>
                        }
                    </div>

                    <div className="p-6 absolute left-0 bottom-0 w-full bg-[#FFFFFF] shadow-[0px_-3px_6px_0px_#0000001F]">
                        <button onClick={handleSetCollection} className={`w-full px-4 py-[6px] rounded-md font-semibold text-[12px] leading-6 text-buttonText ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'}`}>Set</button>
                    </div>
                </>
            }
        </div>
    );
}

export default SelectCategoryCollection;
